// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1756":"5fed841d","5221":"5fed841d","9378":"5fed841d"}[chunkId] + ".chunk.css";
};